var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "timesheets-list layout" },
    [
      _c("remove-timesheet-modal", {
        ref: "removeTimesheetModal",
        on: {
          remove: function ($event) {
            return _vm.applyFilters()
          },
        },
      }),
      _c("column-filter-modal", {
        ref: "tableFilterModal",
        on: { apply: _vm.setTableFilter },
      }),
      _c("columns-modal", {
        ref: "columnsModal",
        attrs: {
          columns: _vm.columnsList,
          "default-selected": _vm.defaultColumns,
        },
        on: { apply: _vm.saveUserColumns },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm._v("Табели учёта рабочего времени"),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button2", {
                attrs: {
                  size: "small",
                  icon: {
                    icon: "bookmark",
                    activeColor: "white",
                  },
                  tooltip: {
                    text: "Добавить в закладки",
                    activeText: "Убрать из закладок",
                  },
                  "active-color": "blue",
                  active: _vm.bookmark,
                },
                on: {
                  click: function ($event) {
                    _vm.bookmark = !_vm.bookmark
                  },
                },
              }),
            ],
            1
          ),
          _vm.canEdit
            ? _c(
                "div",
                { staticClass: "layout-header-action" },
                [
                  _c("c-button2", {
                    attrs: {
                      responsive: true,
                      size: "small",
                      label: "Добавить табель",
                      color: "primary",
                      icon: { icon: "plus", color: "white" },
                    },
                    on: { click: _vm.addTimesheet },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "timesheets-list__content" },
        [
          !_vm.inited
            ? [
                _c("c-loader", {
                  attrs: {
                    active: true,
                    height: 250,
                    label: "Данные загружаются",
                  },
                }),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "timesheets-list-filters" },
                  [
                    _c("month-period-select", {
                      staticClass:
                        "timesheets-list-filters__item timesheets-list-filters__period",
                      attrs: {
                        label: "Период",
                        placeholder: "Весь период",
                        clearable: true,
                      },
                      model: {
                        value: _vm.filters.period,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "period", $$v)
                        },
                        expression: "filters.period",
                      },
                    }),
                    _c("c-input2", {
                      staticClass:
                        "timesheets-list-filters__item timesheets-list-filters__filials",
                      attrs: {
                        type: "select",
                        label: "Филиал",
                        checkbox: true,
                        "checkbox-value": _vm.filters.filialsExcept,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": _vm.checkboxTooltip,
                        multiple: true,
                        searchable: true,
                        clearable: true,
                        placeholder: "Все",
                        items: _vm.collections.filials,
                      },
                      on: {
                        checkboxChange: function ($event) {
                          _vm.filters.filialsExcept = $event
                        },
                      },
                      model: {
                        value: _vm.filters.filials,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "filials", $$v)
                        },
                        expression: "filters.filials",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "timesheets-list-filters__actions timesheets-list-filters__item",
                      },
                      [
                        _c("c-button", {
                          staticClass: "timesheets-list-filters__reset",
                          attrs: { size: "large", label: "Сбросить" },
                          on: { click: _vm.resetFilters },
                        }),
                        _c("c-button", {
                          staticClass: "timesheets-list-filters__apply",
                          attrs: {
                            label: "Применить",
                            color: "blue",
                            size: "large",
                          },
                          on: { click: _vm.applyFilters },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.empty
                  ? [
                      _c("div", { staticClass: "timesheets-list__empty" }, [
                        _vm._v("Нет табелей"),
                      ]),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "timesheets-list__table-actions" },
                        [
                          _c("c-button", {
                            staticClass: "timesheets-list__reset-table-filters",
                            attrs: {
                              responsive: "",
                              disabled: !_vm.hasTableFilters,
                              label: "Сбросить фильтры столбцов",
                              icon: { color: "pink", icon: "filter-drop" },
                              type: "with-icon",
                            },
                            on: { click: _vm.resetTableFilters },
                          }),
                          _c("c-button", {
                            staticClass: "timesheets-list__config-columns",
                            attrs: {
                              responsive: "",
                              label: "Настроить столбцы",
                              icon: "cog",
                              type: "with-icon",
                            },
                            on: { click: _vm.configureColumns },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "timesheets-list__table-wrapper" },
                        [
                          _c(
                            "div",
                            { staticClass: "lg" },
                            [
                              _c(
                                "scrolled-table",
                                { on: { nextPage: _vm.nextPage } },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "h-table timesheets-list__table",
                                    },
                                    [
                                      _c("thead", [
                                        _c(
                                          "tr",
                                          [
                                            _vm._l(
                                              _vm.columns,
                                              function (column) {
                                                return _c(
                                                  "th",
                                                  {
                                                    key: column.code,
                                                    attrs: {
                                                      "data-column":
                                                        column.code,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "h-table__header",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__col-title",
                                                            class: {
                                                              active:
                                                                _vm.sortBy ===
                                                                column.code,
                                                              sorted:
                                                                _vm.sortableColumns.includes(
                                                                  column.code
                                                                ),
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.sort(
                                                                  column.code
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  column.shortName
                                                                ) +
                                                                _vm._s(
                                                                  column.unit
                                                                    ? ", " +
                                                                        column.unit
                                                                    : ""
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "h-table__actions",
                                                          },
                                                          [
                                                            _c("c-button", {
                                                              attrs: {
                                                                icon: "info",
                                                                tooltip:
                                                                  column.fullName,
                                                                size: "small",
                                                                "no-border": "",
                                                              },
                                                            }),
                                                            _vm.tableFilters[
                                                              column.code
                                                            ]
                                                              ? [
                                                                  _c(
                                                                    "c-button",
                                                                    {
                                                                      attrs: {
                                                                        id:
                                                                          `timesheets-list-table-filter--` +
                                                                          column.unique,
                                                                        icon: {
                                                                          icon: "filter-column",
                                                                          activeColor:
                                                                            "blue",
                                                                        },
                                                                        "no-border":
                                                                          "",
                                                                        size: "small",
                                                                        active:
                                                                          !!_vm
                                                                            .tableFilters[
                                                                            column
                                                                              .code
                                                                          ]
                                                                            .value,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.configTableFilter(
                                                                              column
                                                                            )
                                                                          },
                                                                      },
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "b-popover",
                                                                    {
                                                                      attrs: {
                                                                        id: "h-table-filter-popover",
                                                                        placement:
                                                                          "top",
                                                                        triggers:
                                                                          "hover blur",
                                                                        target:
                                                                          `timesheets-list-table-filter--` +
                                                                          column.unique,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm
                                                                              .tableFilters[
                                                                              column
                                                                                .code
                                                                            ]
                                                                              .value
                                                                              ? "Изменить фильтр"
                                                                              : "Применить фильтр"
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _c("th", {
                                              attrs: {
                                                "data-column": "actions",
                                              },
                                            }),
                                          ],
                                          2
                                        ),
                                      ]),
                                      _c(
                                        "tbody",
                                        _vm._l(_vm.list, function (item) {
                                          return _c(
                                            "tr",
                                            {
                                              key: item.id,
                                              staticClass: "timesheet-item",
                                            },
                                            [
                                              _vm._l(
                                                _vm.columns,
                                                function (column) {
                                                  return _c(
                                                    "td",
                                                    {
                                                      key: column.code,
                                                      staticClass:
                                                        "h-table__cell",
                                                      class: {
                                                        "h-table__cell--negative":
                                                          column.code ===
                                                            "penalties" &&
                                                          item.fines > 0,
                                                        "h-table__cell--positive":
                                                          column.code ===
                                                            "bonuses" &&
                                                          item.bonuses > 0,
                                                      },
                                                      attrs: {
                                                        "data-column":
                                                          column.code,
                                                      },
                                                    },
                                                    [
                                                      column.code === "created"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.created
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code === "filial"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.filial
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code === "period"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.period
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code === "author"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.author
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code ===
                                                      "penalties"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.fines.toLocaleString()
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code === "bonuses"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.bonuses.toLocaleString()
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      column.code === "paid"
                                                        ? [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.paid.toLocaleString()
                                                              )
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              _c(
                                                "td",
                                                {
                                                  attrs: {
                                                    "data-column": "actions",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "timesheet-item__actions",
                                                    },
                                                    [
                                                      _c("c-button2", {
                                                        directives: [
                                                          {
                                                            name: "b-popover",
                                                            rawName:
                                                              "v-b-popover.hover.blur.top",
                                                            value:
                                                              "Табель " +
                                                              item.filial +
                                                              ", " +
                                                              item.period,
                                                            expression:
                                                              "'Табель ' + item.filial + ', ' + item.period",
                                                            modifiers: {
                                                              hover: true,
                                                              blur: true,
                                                              top: true,
                                                            },
                                                          },
                                                        ],
                                                        staticClass:
                                                          "timesheet-item__edit",
                                                        attrs: {
                                                          size: "iconic",
                                                          icon: "edit",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toTimesheet(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm.canEdit
                                                        ? _c("c-button2", {
                                                            directives: [
                                                              {
                                                                name: "b-popover",
                                                                rawName:
                                                                  "v-b-popover.hover.blur.top",
                                                                value:
                                                                  "Удалить",
                                                                expression:
                                                                  "'Удалить'",
                                                                modifiers: {
                                                                  hover: true,
                                                                  blur: true,
                                                                  top: true,
                                                                },
                                                              },
                                                            ],
                                                            staticClass:
                                                              "timesheet-item__remove",
                                                            attrs: {
                                                              size: "iconic",
                                                              icon: {
                                                                icon: "trash",
                                                                color:
                                                                  "secondary",
                                                              },
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeTimesheet(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "sm" },
                            [
                              _c(
                                "horizontal-table",
                                { on: { nextPage: _vm.nextPage } },
                                [
                                  _c("table", { staticClass: "h-table" }, [
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(_vm.columns, function (column) {
                                          return _c(
                                            "tr",
                                            {
                                              key: column.code,
                                              attrs: {
                                                "data-column": column.code,
                                              },
                                            },
                                            [
                                              _c("th", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "h-table__title",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "h-table__col-title",
                                                        class: {
                                                          active:
                                                            _vm.sortBy ===
                                                            column.code,
                                                          sorted:
                                                            _vm.sortableColumns.includes(
                                                              column.code
                                                            ),
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.sort(
                                                              column.code
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.shortName
                                                            ) +
                                                            _vm._s(
                                                              column.unit
                                                                ? ", " +
                                                                    column.unit
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "h-table__actions",
                                                      },
                                                      [
                                                        _vm.tableFilters[
                                                          column.code
                                                        ]
                                                          ? [
                                                              _c("c-button", {
                                                                attrs: {
                                                                  icon: {
                                                                    icon: "filter-column",
                                                                    activeColor:
                                                                      "blue",
                                                                  },
                                                                  "no-border":
                                                                    "",
                                                                  size: "small",
                                                                  active:
                                                                    !!_vm
                                                                      .tableFilters[
                                                                      column
                                                                        .code
                                                                    ].value,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.configTableFilter(
                                                                        column
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _vm._l(_vm.list, function (item) {
                                                return _c(
                                                  "td",
                                                  {
                                                    key: item.id,
                                                    staticClass:
                                                      "h-table__cell",
                                                    class: {
                                                      "h-table__cell--negative":
                                                        column.code ===
                                                          "penalties" &&
                                                        item.fines > 0,
                                                      "h-table__cell--positive":
                                                        column.code ===
                                                          "bonuses" &&
                                                        item.bonuses > 0,
                                                    },
                                                    attrs: {
                                                      "data-column":
                                                        column.code,
                                                    },
                                                  },
                                                  [
                                                    column.code === "created"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(item.created)
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "filial"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(item.filial)
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "period"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(item.period)
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "author"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(item.author)
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "penalties"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.fines.toLocaleString()
                                                            )
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "bonuses"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.bonuses.toLocaleString()
                                                            )
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    column.code === "paid"
                                                      ? [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.paid.toLocaleString()
                                                            )
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }),
                                            ],
                                            2
                                          )
                                        }),
                                        _c(
                                          "tr",
                                          [
                                            _c("th", {
                                              attrs: {
                                                "data-column": "actions",
                                              },
                                            }),
                                            _vm._l(_vm.list, function (item) {
                                              return _c(
                                                "td",
                                                {
                                                  key: item.id,
                                                  attrs: {
                                                    "data-column": "actions",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "timesheet-item__actions",
                                                    },
                                                    [
                                                      _c("c-button2", {
                                                        staticClass:
                                                          "timesheet-item__edit",
                                                        attrs: {
                                                          size: "iconic",
                                                          icon: "edit",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toTimesheet(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm.canEdit
                                                        ? _c("c-button2", {
                                                            staticClass:
                                                              "timesheet-item__remove",
                                                            attrs: {
                                                              size: "iconic",
                                                              icon: {
                                                                icon: "trash",
                                                                color:
                                                                  "secondary",
                                                              },
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeTimesheet(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }),
                                          ],
                                          2
                                        ),
                                      ],
                                      2
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          !_vm.loading && !_vm.list.length
                            ? _c(
                                "div",
                                { staticClass: "timesheets-list__not-found" },
                                [_vm._v("Ничего не найдено")]
                              )
                            : _vm._e(),
                          _vm.loading
                            ? _c("c-loader", {
                                staticClass: "timesheets-list__loader",
                                attrs: {
                                  active: _vm.loading,
                                  height: 250,
                                  label: "Данные загружаются",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
              ],
        ],
        2
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.loading
          ? _c("div", { staticClass: "timesheets-list__summary" }, [
              _vm._v(" Показано "),
              _c("b", [_vm._v(_vm._s(_vm.list.length))]),
              _vm._v(" из "),
              _c("b", [_vm._v(_vm._s(_vm.totalCount))]),
            ])
          : _vm._e(),
      ]),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }